import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormData } from "@client/controls/Form/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { submit } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      showSuccessNotification: localState.showSuccessNotification,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: FormData) => dispatch(submit(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
